import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function actionCard(theme: Theme): ComponentStyle {
  return {
    componentName: 'actionCard',
    variants: {
      orange: {
        borderColor: theme.colors.spark.orange5,
        ['&:hover']: {
          borderColor: theme.colors.spark.orange6,

          ['& .actionCardAction']: {
            background: theme.colors.spark.orange6
          }
        }
      }
    }
  };
}
